import {createPortal} from 'react-dom';

import Loading from '@/shared/components/Loading';

type PortalType = 'LOADING';

type Props = {
  isOpen: boolean;
  type: PortalType;
};

const PORTAL_COMPONENTS: Record<PortalType, () => JSX.Element> = {
  LOADING: Loading
};

const Portal = ({isOpen, type}: Props) => {
  const app = document.getElementById('app');

  if (!isOpen || !app) return null;

  const PortalComponent = PORTAL_COMPONENTS[type];

  return <>{createPortal(<PortalComponent />, app)}</>;
};

export default Portal;
